
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.357 20.176c.356-.548-.12-1.176-.773-1.176H9.416c-.653 0-1.129.628-.773 1.176A3.997 3.997 0 0012 22a3.997 3.997 0 003.357-1.824zM6.082 4.666a7.94 7.94 0 00-2.021 5.33l.007 2.151a2 2 0 01-.61 1.445l-1.03.994A1.404 1.404 0 003.405 17h15.012L6.082 4.666zM21.134 16.89a1.415 1.415 0 00.452-2.304l-1-1A2 2 0 0120 12.172V9.97A7.97 7.97 0 007.593 3.349l13.541 13.54z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.293 2.293a1 1 0 011.414 0l18 18a1 1 0 01-1.414 1.414l-18-18a1 1 0 010-1.414z"}})])
          )
        }
      }
    